'use client';
import {
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectItemText,
  SelectValueText,
} from '@/components/ui/select';
import { CHAIN_IDS, CHAIN_INFO } from '@/lib/config/chain';
import { createListCollection, HStack, Image } from '@chakra-ui/react';
import { useChainInfo } from '@/lib/hooks/useChainInfo';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { useLocale } from 'next-intl';

const chainOptions = createListCollection<{
  label: string;
  value: string;
  icon: string;
}>({
  items: Object.values(CHAIN_INFO).map((value) => ({
    label: value.name,
    value: value.id,
    icon: value.icon,
  })),
});

export const MultiChainSelector = () => {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const lastPathname = pathname.split('/').pop();
  const { chainInfo, chainId, setChainId } = useChainInfo();
  const searchParams = useSearchParams();
  const chainIdFromParams = searchParams.get('chainId');
  console.log('chainId in multi chain selector', chainId);
  return (
    <SelectRoot
      minW="100px"
      collection={chainOptions}
      value={[chainId]}
      bg="text.t4"
      rounded="full"
      onValueChange={(e) => {
        if (chainIdFromParams === e.value[0]) {
          return;
        }
        setChainId(e.value[0]);
        if (
          !chainIdFromParams ||
          (e.value[0] === `${CHAIN_IDS.ETHEREUM}` &&
            lastPathname === 'ai-agent')
        ) {
          router.push(`/${locale}/hot-list?chainId=${e.value[0]}`);
        } else {
          router.push(`${pathname}?chainId=${e.value[0]}`);
        }
      }}
    >
      <SelectTrigger rounded="full" cursor="pointer">
        <HStack gap="6px" pl={2}>
          <Image
            src={chainInfo?.icon}
            alt={chainInfo?.name}
            w={5}
            h={5}
            rounded="full"
          />
          <SelectValueText
            w="full"
            maxW="full"
            color="text.t1"
            fontWeight={500}
          />
        </HStack>
      </SelectTrigger>
      <SelectContent p={2} gap={1}>
        {chainOptions.items.map((item) => (
          <SelectItem
            key={item.value}
            item={item}
            py={2}
            px={3}
            gap={'6px'}
            cursor="pointer"
          >
            <Image
              src={item.icon}
              alt={item.label}
              w={5}
              h={5}
              rounded="full"
            />
            <SelectItemText color="text.t1">{item.label}</SelectItemText>
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  );
};
